import React from "react"
import styled from "styled-components"

import { Box, Flex } from "components/box"
import { H4, Paragraph as _Paragraph } from "components/text"
import Icon from "components/icon"

const QuoteContainer = styled(Flex).attrs({
  flexDirection: ["column", "column", "row", "row"],
  alignItems: "center"
})`
  svg {
    width: 3.125rem;
    height: auto;
  }
`

const Paragraph = styled(_Paragraph).attrs({ fontSize: ["0.75rem", null, "1.125rem"] })``

type QuoteArticleProps = {
  text: React.ReactNode
  author: React.ReactNode
}

export const QuoteArticle: React.FC<QuoteArticleProps> = ({ text, author }) => (
  <Box textAlign="center">
    <QuoteContainer>
      <Icon p={[5, 5, 7, 7]} name="startQuote" />
      <Box>
        <H4 mb={[4, 4, 5, 5]}>{text}</H4>
        <Paragraph>- {author}</Paragraph>
      </Box>
      <Icon p={[5, 5, 7, 7]} name="endQuote" />
    </QuoteContainer>
  </Box>
)
